import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import commonLookupService from "../../../services/commonLookupService";
import financialYearService from "../../../services/finYearService";
import { recordError } from "../../../utils/logService";
import dayjs from 'dayjs';
import nysProgrammeService from "../../../services/nysProgrammeService";
import DynamicField from "./DynamicField";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function EditNYSProgramme(props) {
  const [disabled, setDisabled] = useState(true);
  const [titles, setTitles] = useState([]);
  const [finYears, setFinYears] = useState([]);
  const [activeFinYear, setActiveFinYear] = useState([]);

  useEffect(() => {
    onFormLoad();
    loadTitles();
    loadFinancialYears();
  }, [props.record]);

  let msg = "";

  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "EditNYSProgramme";

  const Confirm = () => {
    form.resetFields();
    props.onShow(false);
    setDisabled(true);
  };

  const config = {
    rules: [
      {
        type: "object",
        required: true,
        message: "Please select start date!",
      },
    ],
  };
  const config1 = {
    rules: [
      {
        type: "object",
        required: true,
        message: "Please select end date!",
      },
    ],
  };

  const handleCancel = () => {
    if (
      form.getFieldValue("name") ||
      form.getFieldValue("description") ||
      form.getFieldValue("financialYear") ||
      form.getFieldValue("startDate") ||
      form.getFieldValue("endDate")
    ) {
      setDisabled(false);
    } else {
      form.resetFields();
      props.onShow(false);
      setDisabled(true);
    }
  };

  const loadTitles = async () => {
    try {
      const response = await commonLookupService.getTitles();
      if (response) {
        const { data } = response;

        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loadFinancialYears = async () => {
    try {
      const response = await financialYearService.getAllFinYears();
      if (response) {
        const { data } = response;
        setFinYears(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onFormLoad = () => {
    const data = props.record;
    const {
      id,
      name,
      description,
      financialYear,
      startDate,
      endDate,
      contactName,
      surname,
      title_id,
      email,
      contactNumbers,
    } = data;

    if (!util.isEmpty(data)) {
      form.setFieldsValue({
        id: data.id,
        name: data.name,
        description: data.description,
        financialYear: data.financialYear,
        // startDate: moment(data.startDate, "YYYY-MM-DD"),
        // endDate: moment(data.endDate, "YYYY-MM-DD"),
        startDate: dayjs(new Date(Date.parse(data.start_date))),
        endDate: dayjs(new Date(Date.parse(data.end_date))),
        contactName: data.contactName,
        surname: data.surname,
        title_id: data.title_id,
        email: data.email,
        contactNumbers: data.contactNumbers,
      });
    }
  };

  const updateProgramme = async (values) => {
    const {
      id,
      name,
      description,
      financialYear,
      startDate,
      endDate,
      contactName,
      surname,
      title_id,
      email,
      contactNumbers,
    } = values;

    const finYearData = finYears.find(
      (value) => value.shortValue === financialYear
    );

    let finYear = {};

    if (finYearData != null) {
      finYear = {
        id: finYearData.id,
        shortValue: finYearData.shortValue,
        value: finYearData.value,
        startDate: finYearData.startDate,
        endDate: finYearData.endDate,
      };
    }

    const nysProgrammeData = {
      id: id,
      name: name,
      description: description,
      financialYearId: props.record?.financialYearId,
      startDate: dayjs(values.startDate, "YYYY-MM-DD"),
      endDate: dayjs(values.endDate, "YYYY-MM-DD"),
      nysContact: {
        id: 0,
        name: contactName,
        surname: surname,
        title_id: title_id,
        email: email,
        contactNumbers: contactNumbers,
      },
    };

    const entity = "NYS Programme";
    // const hide = message.loading("Submitting in progress, please wait...", 0);
    try {
      const response = await nysProgrammeService.updateNYSProgramme(
        nysProgrammeData
      );
      if (response && (response.status === 201 || response.status === 200)) {
        props.onShow(false);
        // hide();
        msg = util.parseMessage(Messages.UPDATE_SUCCESS, entity);
        openNotification("Update NYS Programme", msg, Notify.SUCCESS);
        props.setHasUpdated(true);
      } else {
        msg = util.parseMessage(Messages.UPDATE_FAILURE, entity);
        openNotification("Update NYS Programme", msg, Notify.ERROR);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.UPDATE_FAILURE, entity);
      openNotification("Update NYS Programme", msg, Notify.ERROR);
      recordError(error);
    }
  };

  return (
    <>
      <Modal
        forceRender
        title="Update NYS Programme Details"
        key="nys-update-modal-programme"
        open={props.visible}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={900}
        footer={[
          <div key="modal-footer-buttons" className="modal-footer-buttons">
            <Button
              key="2"
              type="primary"
              htmlType="submit"
              onSubmit={updateProgramme}
              form={formName}
            >
              Save
            </Button>
            <Popconfirm
              key="1"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
                key="nys-confirm-btn"
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={updateProgramme}
        >
          <h4 key="nys-programme-title">
            <b>NYS Programme</b>
          </h4>
          <Card key="nys-programme-card">
            <Form.Item hidden={true} name="id" label="id">
              <Input name="id" />
            </Form.Item>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme name",
                },
              ]}
            >
              <Input name="name" />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please provide NYS programme description",
                },
              ]}
            >
              <Input name="description" />
            </Form.Item>
            <Form.Item
              name="startDate"
              label="Opening Date"
              placeholder="Select programme opening date"
              {...config}
              rules={[
                {
                  required: true,
                  message: "Please select programme opening date",
                },
                {
                  validator: async (_, startDate) => {
                    const selectedFinYear = form.getFieldValue("financialYear");

                    const sepIndex = selectedFinYear.indexOf("/");
                    const fullPrevYear = `${selectedFinYear
                      .toString()
                      .substr(0, sepIndex)}`;
                    const fullNextYear = `${
                      parseInt(selectedFinYear.toString().substr(0, sepIndex)) +
                      1
                    }`;

                    if (startDate != null) {
                      var startDate1 = form
                        .getFieldValue("startDate")
                        .format("YYYY-MM-DD");

                      var endDate = form
                        .getFieldValue("endDate")
                        .format("YYYY-MM-DD");

                      if (startDate1 != null) {
                        // if (startDate1 < activeFinYear.startDate) {
                        //   return Promise.reject(
                        //     "Start date must not be before " +
                        //       activeFinYear.startDate
                        //   );
                        // }
                        if (startDate1 > endDate) {
                          return Promise.reject(
                            "Opening date must not be after " + endDate
                          );
                        }

                        if (
                          dayjs(startDate1).format("YYYY") < fullPrevYear ||
                          dayjs(startDate1).format("YYYY") > fullNextYear
                        ) {
                          return Promise.reject(
                            "Opening date cannot be before " +
                              fullPrevYear +
                              " or after " +
                              fullNextYear
                          );
                        }
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item
              name="endDate"
              label="Closing Date"
              placeholder="Select closing date"
              {...config1}
              rules={[
                {
                  required: true,
                  message: "Please select programme closing date",
                },
                {
                  validator: async (_, endDate) => {
                    const selectedFinYear = form.getFieldValue("financialYear");

                    const sepIndex = selectedFinYear.indexOf("/");
                    const fullPrevYear = `${selectedFinYear
                      .toString()
                      .substr(0, sepIndex)}`;
                    const fullNextYear = `${
                      parseInt(selectedFinYear.toString().substr(0, sepIndex)) +
                      1
                    }`;

                    if (endDate != null) {
                      var endDate1 = form
                        .getFieldValue("endDate")
                        .format("YYYY-MM-DD");
                      var startDate = form
                        .getFieldValue("startDate")
                        .format("YYYY-MM-DD");

                      if (endDate1 != null) {
                        // if (endDate1 < activeFinYear.startDate) {
                        //   return Promise.reject(
                        //     "End date must not be before " +
                        //       endDate
                        //   );
                        // }
                        // if (endDate1 > endDate) {
                        //   return Promise.reject(
                        //     "End date must not be after " +
                        //       endDate
                        //   );
                        // }
                        if (endDate1 < startDate) {
                          return Promise.reject(
                            "Closing date cannot be before " + startDate
                          );
                        }

                        if (
                          dayjs(endDate1).format("YYYY") < fullPrevYear ||
                          dayjs(endDate1).format("YYYY") > fullNextYear
                        ) {
                          return Promise.reject(
                            "Closing date cannot be before " +
                              fullPrevYear +
                              " or after " +
                              fullNextYear
                          );
                        }
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item
              key="fin-year"
              name="financialYear"
              label="Financial Year"
            >
              <Input disabled={true} />
            </Form.Item>
          </Card>
          <h4 key="nys-programme-contact">
            <b>Contact Person</b>
          </h4>
          <Card key="nys-programme-contact-details">
            <Form.Item
              name="contactName"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please provide a valid name",
                },
              ]}
            >
              <Input name="contactName" />
            </Form.Item>
            <Form.Item
              name="surname"
              label="Surname"
              rules={[
                {
                  required: true,
                  message: "Please select a vlid surname",
                },
              ]}
            >
              <Input name="surname" />
            </Form.Item>
            <Form.Item
              name="title_id"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please select a valid title",
                },
              ]}
            >
              <Select allowClear placeholder="Please select">
                {titles.map((title) => {
                  return (
                    <Option key={title.key} value={title.key}>
                      {title.value}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail",
                },
                {
                  required: true,
                  message: "Please provide valid email",
                },
              ]}
            >
              <Input name="email" />
            </Form.Item>
            <DynamicField key="dynamic-control" />
          </Card>
        </Form>
      </Modal>
    </>
  );
}
